import { useEffect, useState } from "react";
import MobileLeftSection from "../../Components/MobileLeftSection";
import MobileHeaderSection from "../../Components/MobileHeaderSection";
import MobileBottomMenu from "../../Components/MobileBottomMenu";
import Loading from "../../Components/Loading";
import { useSelector } from "react-redux";
import CalendarBox from "./CalenderBox";
import Lock from "../../Components/Lock";
export default function MobileAttendance({
  AttendanceData,
  goToPreviousMonth,
  goToNextMonth,
  batchDet,
  currentMonth,
  currentYear,
}) {
  const [SideOpener, setSideOpner] = useState(false);
  const { loading: loadingPack, PackageRec } = useSelector(
    (s) => s.Package_List_Reducer
  );
  const OpenSideMenu = (e) => {
    setSideOpner(!SideOpener);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {loadingPack ? <Loading /> : ""}
      <div className="Mobile_View_css">
        <div
          onClick={OpenSideMenu}
          className={SideOpener ? "menu-overlay active" : "menu-overlay"}
          id="menuOverlay"
        ></div>
        <MobileLeftSection SideOpener={SideOpener} Page="Attendance" />
        <div className="main-content">
          <MobileHeaderSection Page="Attendance" OpenSideMenu={OpenSideMenu} />
          <div className="page-content" id="attendancePage">
            {/* <!-- Attendance Stats --> */}
            {batchDet ? (
              <section className="attendance-stats">
                <div className="stats-grid">
                  <div className="stat-card total-days">
                    <div className="stat-icon">
                      <div className="calendar-icon">
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.25 8.5C4.91848 8.5 4.60054 8.6317 4.36612 8.86612C4.1317 9.10054 4 9.41848 4 9.75C4 10.0815 4.1317 10.3995 4.36612 10.6339C4.60054 10.8683 4.91848 11 5.25 11C5.58152 11 5.89946 10.8683 6.13388 10.6339C6.3683 10.3995 6.5 10.0815 6.5 9.75C6.5 9.41848 6.3683 9.10054 6.13388 8.86612C5.89946 8.6317 5.58152 8.5 5.25 8.5ZM12.75 8.5C12.4185 8.5 12.1005 8.6317 11.8661 8.86612C11.6317 9.10054 11.5 9.41848 11.5 9.75C11.5 10.0815 11.6317 10.3995 11.8661 10.6339C12.1005 10.8683 12.4185 11 12.75 11C13.0815 11 13.3995 10.8683 13.6339 10.6339C13.8683 10.3995 14 10.0815 14 9.75C14 9.41848 13.8683 9.10054 13.6339 8.86612C13.3995 8.6317 13.0815 8.5 12.75 8.5ZM7.75 9.75C7.75 9.41848 7.8817 9.10054 8.11612 8.86612C8.35054 8.6317 8.66848 8.5 9 8.5C9.33152 8.5 9.64946 8.6317 9.88388 8.86612C10.1183 9.10054 10.25 9.41848 10.25 9.75C10.25 10.0815 10.1183 10.3995 9.88388 10.6339C9.64946 10.8683 9.33152 11 9 11C8.66848 11 8.35054 10.8683 8.11612 10.6339C7.8817 10.3995 7.75 10.0815 7.75 9.75ZM5.25 12.5C4.91848 12.5 4.60054 12.6317 4.36612 12.8661C4.1317 13.1005 4 13.4185 4 13.75C4 14.0815 4.1317 14.3995 4.36612 14.6339C4.60054 14.8683 4.91848 15 5.25 15C5.58152 15 5.89946 14.8683 6.13388 14.6339C6.3683 14.3995 6.5 14.0815 6.5 13.75C6.5 13.4185 6.3683 13.1005 6.13388 12.8661C5.89946 12.6317 5.58152 12.5 5.25 12.5ZM7.75 13.75C7.75 13.4185 7.8817 13.1005 8.11612 12.8661C8.35054 12.6317 8.66848 12.5 9 12.5C9.33152 12.5 9.64946 12.6317 9.88388 12.8661C10.1183 13.1005 10.25 13.4185 10.25 13.75C10.25 14.0815 10.1183 14.3995 9.88388 14.6339C9.64946 14.8683 9.33152 15 9 15C8.66848 15 8.35054 14.8683 8.11612 14.6339C7.8817 14.3995 7.75 14.0815 7.75 13.75Z"
                            fill="#9747FF"
                          />
                          <path
                            d="M7.72703 0H11.273C12.4586 0 13.3988 -8.45742e-08 14.1555 0.0616215C14.9307 0.124324 15.5854 0.256216 16.1847 0.558919C17.155 1.05172 17.9436 1.83775 18.4376 2.80432C18.7427 3.39892 18.8751 4.05189 18.9381 4.82378C19 5.5773 19 6.51351 19 7.69405V12.3059C19 13.4865 19 14.4227 18.9381 15.1762C18.8751 15.9481 18.7427 16.6 18.4387 17.1968C17.9441 18.1627 17.1551 18.9479 16.1847 19.44C15.5854 19.7438 14.9307 19.8757 14.1555 19.9384C13.3988 20 12.4586 20 11.273 20H7.72703C6.54143 20 5.6012 20 4.84446 19.9384C4.06926 19.8757 3.41457 19.7438 2.81634 19.4411C1.84587 18.9487 1.05685 18.1631 0.5624 17.1968C0.257314 16.6 0.124857 15.9481 0.0618856 15.1762C-8.49366e-08 14.4227 0 13.4865 0 12.3059V7.69405C0 6.51351 -8.49366e-08 5.5773 0.0618856 4.82378C0.124857 4.05189 0.257314 3.4 0.561314 2.80432C1.05605 1.83782 1.84546 1.05216 2.81634 0.56C3.41349 0.256216 4.06926 0.124324 4.84446 0.0616215C5.6012 -8.45742e-08 6.54143 0 7.72703 0ZM1.62857 7.2973V12.2703C1.62857 13.4951 1.62857 14.3643 1.68503 15.0443C1.73931 15.7146 1.84463 16.1308 2.01291 16.4605C2.35118 17.1215 2.89086 17.6589 3.55463 17.9957C3.88577 18.1632 4.30377 18.267 4.97691 18.3222C5.66091 18.3773 6.53383 18.3784 7.76286 18.3784H11.2371C12.4673 18.3784 13.3402 18.3784 14.0231 18.3222C14.6962 18.2681 15.1142 18.1632 15.4454 17.9957C16.1091 17.6589 16.6488 17.1215 16.9871 16.4605C17.1554 16.1308 17.2596 15.7146 17.315 15.0443C17.3703 14.3632 17.3714 13.4941 17.3714 12.2703V7.2973H1.62857ZM6.78571 3.24324C6.49777 3.24324 6.22161 3.35714 6.018 3.55988C5.81439 3.76263 5.7 4.0376 5.7 4.32432C5.7 4.61104 5.81439 4.88602 6.018 5.08876C6.22161 5.29151 6.49777 5.40541 6.78571 5.40541H12.2143C12.5022 5.40541 12.7784 5.29151 12.982 5.08876C13.1856 4.88602 13.3 4.61104 13.3 4.32432C13.3 4.0376 13.1856 3.76263 12.982 3.55988C12.7784 3.35714 12.5022 3.24324 12.2143 3.24324H6.78571Z"
                            fill="#9747FF"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">Total Days</span>
                      <span className="stat-value">
                        {AttendanceData?.TotalAttendance || 0}
                      </span>
                    </div>
                  </div>

                  <div className="stat-card present">
                    <div className="stat-icon">
                      <div className="attendance-icon present-icon">
                        <svg
                          width="20"
                          height="22"
                          viewBox="0 0 20 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_2370_9822"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="22"
                          >
                            <path
                              d="M10 9C12.2091 9 14 7.20914 14 5C14 2.79086 12.2091 1 10 1C7.79086 1 6 2.79086 6 5C6 7.20914 7.79086 9 10 9Z"
                              fill="#555555"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19 21C19 16.0295 14.9705 12 10 12C5.0295 12 1 16.0295 1 21"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13 17L9 21L7 19"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </mask>
                          <g mask="url(#mask0_2370_9822)">
                            <path d="M-2 -1H22V23H-2V-1Z" fill="#33A731" />
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">Present</span>
                      <span className="stat-value">
                        {AttendanceData?.Present || 0}
                      </span>
                    </div>
                  </div>

                  <div className="stat-card absent">
                    <div className="stat-icon">
                      <div className="attendance-icon absent-icon">
                        <svg
                          width="20"
                          height="22"
                          viewBox="0 0 20 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_2370_9833"
                            style={{ maskType: "luminance" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="20"
                            height="22"
                          >
                            <path
                              d="M10 9C12.2091 9 14 7.20914 14 5C14 2.79086 12.2091 1 10 1C7.79086 1 6 2.79086 6 5C6 7.20914 7.79086 9 10 9Z"
                              fill="#555555"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M19 21C19 16.0295 14.9705 12 10 12C5.0295 12 1 16.0295 1 21M8 17L12 21M12 17L8 21"
                              stroke="white"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </mask>
                          <g mask="url(#mask0_2370_9833)">
                            <path d="M-2 -1H22V23H-2V-1Z" fill="#E1491B" />
                          </g>
                        </svg>
                      </div>
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">Absent</span>
                      <span className="stat-value">
                        {AttendanceData?.Absent || 0}
                      </span>
                    </div>
                  </div>

                  <div className="stat-card attendance-percent">
                    <div className="stat-icon">
                      <div className="percentage-icon">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.5 13.125C13.5 13.3475 13.434 13.565 13.3104 13.75C13.1868 13.935 13.0111 14.0792 12.8055 14.1644C12.6 14.2495 12.3738 14.2718 12.1555 14.2284C11.9373 14.185 11.7368 14.0778 11.5795 13.9205C11.4222 13.7632 11.315 13.5627 11.2716 13.3445C11.2282 13.1262 11.2505 12.9 11.3356 12.6945C11.4208 12.4889 11.565 12.3132 11.75 12.1896C11.935 12.066 12.1525 12 12.375 12C12.6734 12 12.9595 12.1185 13.1705 12.3295C13.3815 12.5405 13.5 12.8266 13.5 13.125ZM5.625 6C5.8475 6 6.06501 5.93402 6.25002 5.8104C6.43502 5.68679 6.57922 5.51109 6.66436 5.30552C6.74951 5.09995 6.77179 4.87375 6.72838 4.65552C6.68498 4.43729 6.57783 4.23684 6.4205 4.0795C6.26316 3.92217 6.06271 3.81502 5.84448 3.77162C5.62625 3.72821 5.40005 3.75049 5.19448 3.83564C4.98891 3.92078 4.81321 4.06498 4.6896 4.24998C4.56598 4.43499 4.5 4.6525 4.5 4.875C4.5 5.17337 4.61853 5.45952 4.8295 5.6705C5.04048 5.88147 5.32663 6 5.625 6ZM18 1.5V16.5C18 16.8978 17.842 17.2794 17.5607 17.5607C17.2794 17.842 16.8978 18 16.5 18H1.5C1.10218 18 0.720644 17.842 0.43934 17.5607C0.158035 17.2794 0 16.8978 0 16.5V1.5C0 1.10218 0.158035 0.720644 0.43934 0.43934C0.720644 0.158035 1.10218 0 1.5 0H16.5C16.8978 0 17.2794 0.158035 17.5607 0.43934C17.842 0.720644 18 1.10218 18 1.5ZM3 4.875C3 5.39418 3.15395 5.90169 3.44239 6.33337C3.73083 6.76505 4.1408 7.1015 4.62046 7.30018C5.10011 7.49886 5.62791 7.55085 6.13711 7.44956C6.64631 7.34828 7.11404 7.09827 7.48116 6.73116C7.84827 6.36404 8.09828 5.89631 8.19956 5.38711C8.30085 4.87791 8.24886 4.35011 8.05018 3.87046C7.8515 3.3908 7.51505 2.98083 7.08337 2.69239C6.65169 2.40395 6.14418 2.25 5.625 2.25C4.92881 2.25 4.26113 2.52656 3.76884 3.01884C3.27656 3.51113 3 4.17881 3 4.875ZM15 13.125C15 12.6058 14.846 12.0983 14.5576 11.6666C14.2692 11.2349 13.8592 10.8985 13.3795 10.6998C12.8999 10.5011 12.3721 10.4492 11.8629 10.5504C11.3537 10.6517 10.886 10.9017 10.5188 11.2688C10.1517 11.636 9.90172 12.1037 9.80044 12.6129C9.69915 13.1221 9.75114 13.6499 9.94982 14.1295C10.1485 14.6092 10.4849 15.0192 10.9166 15.3076C11.3483 15.596 11.8558 15.75 12.375 15.75C13.0712 15.75 13.7389 15.4734 14.2312 14.9812C14.7234 14.4889 15 13.8212 15 13.125ZM14.7806 3.21937C14.711 3.14964 14.6283 3.09432 14.5372 3.05658C14.4462 3.01884 14.3486 2.99941 14.25 2.99941C14.1514 2.99941 14.0538 3.01884 13.9628 3.05658C13.8717 3.09432 13.789 3.14964 13.7194 3.21937L3.21937 13.7194C3.07864 13.8601 2.99958 14.051 2.99958 14.25C2.99958 14.449 3.07864 14.6399 3.21937 14.7806C3.36011 14.9214 3.55098 15.0004 3.75 15.0004C3.94902 15.0004 4.13989 14.9214 4.28063 14.7806L14.7806 4.28063C14.8504 4.21097 14.9057 4.12825 14.9434 4.03721C14.9812 3.94616 15.0006 3.84856 15.0006 3.75C15.0006 3.65144 14.9812 3.55384 14.9434 3.46279C14.9057 3.37175 14.8504 3.28903 14.7806 3.21937Z"
                            fill="#F4A42C"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="stat-info">
                      <span className="stat-label">Attendance</span>
                      <span className="stat-value">
                        {Math.ceil(AttendanceData?.Percentage) + "%" || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            ) : (
              <div style={{ padding: "20px" }}>
                {" "}
                <Lock />
              </div>
            )}
            {/* <!-- Calendar Section --> */}
            {batchDet ? (
              <section className="calendar-section">
                <div className="calendar-header">
                  <h3>Total Days</h3>
                </div>

                <CalendarBox
                  goToNextMonth={goToNextMonth}
                  goToPreviousMonth={goToPreviousMonth}
                  month={currentMonth}
                  year={currentYear}
                />

                {/* 
                
                <div className="calendar-container">
                <div className="calendar-nav">
                  <button className="nav-btn prev-btn">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="15,18 9,12 15,6" />
                    </svg>
                  </button>
                  <h4 className="month-year">June 2025</h4>
                  <button className="nav-btn next-btn">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <polyline points="9,18 15,12 9,6" />
                    </svg>
                  </button>
                </div>

                <div className="calendar-grid">
                  <div className="calendar-header-row">
                    <div className="day-header">Mo</div>
                    <div className="day-header">Tu</div>
                    <div className="day-header">We</div>
                    <div className="day-header">Th</div>
                    <div className="day-header">Fr</div>
                    <div className="day-header">Sa</div>
                    <div className="day-header">Su</div>
                  </div>

                  <div className="calendar-days">
                    <div className="day prev-month">31</div>
                    <div className="day">1</div>
                    <div className="day">2</div>
                    <div className="day">3</div>
                    <div className="day present">4</div>
                    <div className="day present">5</div>
                    <div className="day">6</div>
                    <div className="day">7</div>
                    <div className="day present">8</div>
                    <div className="day">9</div>
                    <div className="day">10</div>
                    <div className="day">11</div>
                    <div className="day">12</div>
                    <div className="day present">13</div>
                    <div className="day">14</div>
                    <div className="day">15</div>
                    <div className="day">16</div>
                    <div className="day present">17</div>
                    <div className="day">18</div>
                    <div className="day">19</div>
                    <div className="day">20</div>
                    <div className="day present">21</div>
                    <div className="day">22</div>
                    <div className="day">23</div>
                    <div className="day">24</div>
                    <div className="day present">25</div>
                    <div className="day present">26</div>
                    <div className="day">27</div>
                    <div className="day">28</div>
                    <div className="day">29</div>
                    <div className="day">30</div>
                    <div className="day next-month">1</div>
                  </div>
                </div>
              </div> */}
              </section>
            ) : (
              ""
            )}
          </div>
          <MobileBottomMenu Page="Attendance" />
        </div>
      </div>
    </>
  );
}
